module.exports = __webpack_public_path__ + "canny-salesforce-integration-00b74bc1311e9ea83f59f33ad66ba105.png";